<script setup lang="ts">
import { isClient } from '@vueuse/core'

const props = withDefaults(defineProps<{
  title?: StoryBlokHeading
  type: 'slideshow' | 'static'
  items: any[]
  disableNegativeMargin?: boolean
}>(), {
  disableNegativeMargin: false,
})

const options = ref(1)
onMounted(() => {
  options.value = (() => {
    if (!isClient) return
    if (props.type === 'static') return 1
    const shouldntAnimate = window.innerWidth < 1220 ? (((window.innerWidth - 240) / 140) >= props.items.length) : props.items.length <= 7
    return shouldntAnimate ? 1 : props.items.length <= 13 ? 3 : 2
  })()
})
</script>

<template>
  <div :class="{ '-mt-17.5': !disableNegativeMargin }">
    <StoryblokHeading v-if="title" class="text-center px-5 mb-5 title" :title="title" />
    <div class="min-h-100px flex items-center justify-center" :class="{ 'mx-auto': type === 'static' }">
      <div class="max-w-full flex" :class="options === 1 ? 'static' : 'slideshow'">
        <div
          v-for="i in options"
          :key="i"
          class="flex"
          :style="options !== 1 ? { 'width': `${items?.length * 140}px`, 'animation-duration': `${items?.length * 2}s` } : ''"
        >
          <span v-for="img in items" class="flex items-center justify-center w-[140px]">
            <StoryblokImage class="w-100px" fit :src="img" width="200" no-lazy />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.static {
  @apply justify-center flex-wrap;
  & > div {
    @apply flex-wrap justify-center gap-5;
  }
}
.slideshow {
  @apply overflow-hidden absolute left-0;
  & > div {
    animation: slide linear infinite;
  }
  &:hover {
    & > div {
      animation-play-state: paused;
    }
  }
}

@keyframes slide {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

.title {
  @media (max-width: 639px) {
    @apply pt-10;
  }
}
</style>
